import { useContext, useEffect, useState } from "react";
import CustomPDFViewer from "../../components/Home/CustomPDFViewer";
import FooterPdf from "../../components/Home/FooterPdf";
import SideSettings from "../../components/Home/Section";
import { Collapse } from "../../components/Home/Section/styled";
import Header from "../../components/Sign/Header";
import { CheckboxGroupProvider } from "../../context/CheckboxGroup";
import { SelectNameProvider } from "../../context/CheckboxName";
import {
  EmailChecklistContext,
  EmailChecklistProvider,
} from "../../context/EmailChecklistContext";
import { EmailSelectedProvider } from "../../context/EmailSelectedContext";
import { IsDragContextProvider } from "../../context/IsDragContext";
import { SaveTemplateContextProvider } from "../../context/SaveTemplateContext";
import { SelfContextProvider } from "../../context/SelfContext";
import { SignTypeProvider } from "../../context/SignTypeContext";
import { getData } from "../../service/getData";
import { getToken } from "../../service/getToken";
import { Main } from "../../styled";
import ArrowCircleLeft from "../../svg/ArrowCircleLeft";
import ArrowCircleRight from "../../svg/ArrowCircleRight";

type EmailChecklist = {
  [email: string]: {
    send_self: boolean;
    signature_digital: boolean;
    order: number;
  };
};
type Signatories = {
  email: string;
  document: string;
  color: string;
}[];

const Home = () => {
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfNameDocument, setPdfNameDocument] = useState("");
  const [signatoriesList, setSignatoriesList] = useState<Signatories>([]);
  const [modeSign, setModeSign] = useState<string>("");
  const [urlDestination, setUrlDestination] = useState<string>("");
  const [collapse, setCollapse] = useState(true);
  const { setEmailChecklist } = useContext(EmailChecklistContext);

  useEffect(() => {
    const initialChecklist: EmailChecklist = {};
    const fetchData = async () => {
      try {
        await getToken();

        const data = await getData();
        if (data && data.request.mode_sign) {
          setModeSign(data.request.mode_sign);
        }
        if (data && data.document.path) {
          setPdfUrl(data.document.path);
        }
        if (data && data.signatories && data.signatories.length > 0) {
          data.signatories.forEach(
            (option: { email: string; document: string; color: string }) => {
              initialChecklist[option.email] = {
                send_self: false,
                signature_digital: false,
                order: 0,
              };
            }
          );
          setSignatoriesList(data.signatories);
          setEmailChecklist(initialChecklist);
        }
        if (data && data.document.name) {
          setPdfNameDocument(data.document.name);
        }
        if (data && data.request.redirect_to) {
          setUrlDestination(data.request.redirect_to);
        }
      } catch (error) {
        console.error("Erro ao renderizar o PDF", error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openCollapse = () => {
    setCollapse(!collapse);
  };

  return (
    <IsDragContextProvider>
      <CheckboxGroupProvider>
        <SelectNameProvider>
          <EmailChecklistProvider>
            <SaveTemplateContextProvider>
              <SelfContextProvider>
                <SignTypeProvider>
                  <EmailSelectedProvider>
                    <Header visible={false} currentStep={0} isHome={true} />
                    <Main>
                      <Collapse hasCollapse={collapse} onClick={openCollapse}>
                        {collapse ? <ArrowCircleLeft /> : <ArrowCircleRight />}
                      </Collapse>
                      <SideSettings
                        signatoriesList={signatoriesList}
                        collapse={collapse}
                      />
                      <CustomPDFViewer
                        pdfUrl={pdfUrl}
                        pdfName={pdfNameDocument}
                      />
                    </Main>
                    <FooterPdf
                      modeSign={modeSign}
                      urlDestination={urlDestination}
                      signatoriesList={signatoriesList}
                    />
                  </EmailSelectedProvider>
                </SignTypeProvider>
              </SelfContextProvider>
            </SaveTemplateContextProvider>
          </EmailChecklistProvider>
        </SelectNameProvider>
      </CheckboxGroupProvider>
    </IsDragContextProvider>
  );
};

export default Home;
